import React, { useState } from "react";
import { Spinner } from "reactstrap";

interface SpinnerLinkProps {
    caption: string;                // Caption for the link
    captionProcess: string;
    onClick: () => Promise<void>;   // Callback function to call when the link is clicked
}

const SpinnerLink: React.FC<SpinnerLinkProps> = ({ caption, captionProcess, onClick }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault(); // Prevent default anchor behavior
        setLoading(true);   // Show spinner and disable link

        try {
            await onClick();  // Call the provided callback function
        } finally {
            setLoading(false); // Hide spinner and enable link after the callback
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {loading && (
                <Spinner color="primary" size="sm"></Spinner>
            )}
            <a href="#" onClick={handleClick} style={{ pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.5 : 1 }}>
                {loading ? (" " + captionProcess) : caption}
            </a>
        </div>
    );
};

export default SpinnerLink;

/* usage example

import SpinnerLink from "./SpinnerLink";


  const handleClick = async () => {
    // Simulate an asynchronous operation (e.g., API call)
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        //console.log("Operation completed!");
        resolve();
      }, 2000); // Simulate a 2-second operation
    });
  };

  return (
    <div>
      <h1>My App</h1>
      <SpinnerLink caption="Send OTP" onClick={handleClick} />
    </div>
  );

*/